import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Tooltip } from 'react-native-paper';
import { styles } from './ProfileViewStyle';
import { useIsShiftPressed } from './ShiftKeyContext';
import { useIsNarrowForm } from './ResponsiveFormContext';
import { LabeledCheckbox } from '../components/LabeledCheckbox';
export const FoodCheckboxes = ({ foods, valuePrefix, values, readOnly, labelTransformer, }) => {
    const isShiftPressed = useIsShiftPressed();
    // Phone-sized public sign-up: two per row.
    const narrow = useIsNarrowForm();
    return (<View style={styles.checkboxContainer}>
      {foods
            .slice()
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(food => {
            const name = `${valuePrefix}${food.awfId}`;
            const label = labelTransformer(food);
            const checkbox = (<LabeledCheckbox key={name} name={name} label={label} checked={values[name]} readOnly={readOnly}/>);
            return (<View style={[
                    styles.checkboxWrapper,
                    narrow && localStyles.narrowWrapper,
                ]} key={food.awfId}>
              {/* This inner View ensures the Tooltip's hover area
                    is only as wide as the checkbox and its label. */}
              <View style={localStyles.row}>
                {isShiftPressed ? (<Tooltip title={`awfId: ${food.awfId}, fdcId: ${food.fdcId}, portions: ${food.portions?.length || 0}`}>
                    {checkbox}
                  </Tooltip>) : (checkbox)}
              </View>
            </View>);
        })}
    </View>);
};
const localStyles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
    narrowWrapper: {
        flexBasis: '50%',
        maxWidth: '50%',
    },
});
